import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    delete: string;
    menuTitle: string;
    projectNotifications: string;
    workspaceSettings: string;
    workspaceRequired: string;
    workspacesNavigationContextMenuAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label to delete a workspace */
            delete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu_ContextMenu.delete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu group title for workspace actions */
            menuTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu_ContextMenu.menuTitle?c=fvis4ig6qtg3", defaultMessage: "Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for toggling project notifications */
            projectNotifications: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu_ContextMenu.projectNotifications?c=3hjera547wu4o", defaultMessage: "Project Notifications" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to open workspace settings */
            workspaceSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu_ContextMenu.workspaceSettings?c=94fve250vbfs", defaultMessage: "Workspace Settings" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Disabled state message when workspace deletion is unavailable */
            workspaceRequired: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu_ContextMenu.workspaceRequired?c=1psx5lyolsojp", defaultMessage: "You must have at least one workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the workspaces navigation context menu */
            workspacesNavigationContextMenuAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu_ContextMenu.workspacesNavigationContextMenuAriaLabel?c=xxgc87ymukqu", defaultMessage: "Workspaces Navigation Context Menu" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
